var render, staticRenderFns
import script from "./SubNavigation.vue?vue&type=script&lang=ts&"
export * from "./SubNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./SubNavigation.vue?vue&type=style&index=0&id=40a22ee7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports